<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  onClicked: {
    type: Function,
    required: true,
  },
  currentSection: {
    type: String,
    default: '',
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
  resumeLanguage: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div
    v-if="content.missions"
    class="experience experience-mission"
    :class="content.indentation ? content.indentation : 'none'"
  >
    <div class="date" />
    <div class="timeline no-bullet" />
    <div class="data">
      <div
        class="section missions"
        :class="{ selected: isSelected && currentSection === 'missions' }"
        @click="onClicked('missions')"
      >
        <div class="subtitle">{{ $t(`resume.sections.${resumeLanguage}.common-missions`) }}</div>
        <div class="items" v-html="content.missions"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.subtitle {
  text-transform: uppercase;
  color: var(--color1);
  font-weight: 700;
}

.section,
.date {
  &:hover,
  &.selected {
    background-color: #fff9ef;
    cursor: pointer;
    border-radius: 12px;
  }
}
</style>
